<template>
  <v-stepper
    v-model="step"
    class="transparent elevation-0"
  >
    <v-stepper-header class="d-flex flex-nowrap">
      <v-stepper-step
        :complete="step > 1"
        :complete-icon="null"
        :edit-icon="null"
        :error-icon="null"
        data-step="1"
        :color="step === 1 ? 'primary' : 'border'"
        step="1"
        class="bi-parameter-rule-stepper font-weight-bold ui-text-md"
      >
        {{ $t('biControlPanel.parameterRules.wizard.step1') }}
      </v-stepper-step>

      <v-divider />

      <v-stepper-step
        :complete="false"
        :complete-icon="null"
        :edit-icon="null"
        :error-icon="null"
        data-step="2"
        step="2"
        class="bi-parameter-rule-stepper pr-0 font-weight-bold ui-text-md"
      >
        {{ $t('biControlPanel.parameterRules.wizard.step2') }}
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import BiPanelRuleModule from '@/store/modules/bi-panel-rule/bi-panel-rule-module';

export default {
  name: 'BIParameterRuleStepper',
  computed: {
    step() {
      return BiPanelRuleModule.form.step;
    },
  },
};
</script>

<style lang="scss">
.bi-parameter-rule-stepper.v-stepper__step--complete .v-stepper__step__step .v-icon {
  display: none !important;
}

.bi-parameter-rule-stepper {
  position: relative;
}

.bi-parameter-rule-stepper.v-stepper__step--complete::after {
  content: attr(data-step);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(100%, -50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1;
  pointer-events: none;
}
</style>
